import { render, staticRenderFns } from "./InboxContentNewLead.vue?vue&type=template&id=49da48a5&"
import script from "./InboxContentNewLead.vue?vue&type=script&lang=js&"
export * from "./InboxContentNewLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports